/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Endpoint_Providers_NoteInputs */

const en_app_endpoint_providers_note = /** @type {(inputs: App_Endpoint_Providers_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uptime, latency and share of calls measured across all AnyAPI traffic, not your account.`)
};

const zh_hans1_app_endpoint_providers_note = /** @type {(inputs: App_Endpoint_Providers_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用率、延迟和调用占比基于 AnyAPI 的全部流量测量，而不只是你的账户。`)
};

const pt_br2_app_endpoint_providers_note = /** @type {(inputs: App_Endpoint_Providers_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilidade, latência e participação nas chamadas medidas em todo o tráfego da AnyAPI, não só na sua conta.`)
};

const es_app_endpoint_providers_note = /** @type {(inputs: App_Endpoint_Providers_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilidad, latencia y proporción de llamadas medidas en todo el tráfico de AnyAPI, no en tu cuenta.`)
};

const fr_app_endpoint_providers_note = /** @type {(inputs: App_Endpoint_Providers_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilité, latence et part des appels mesurées sur l’ensemble du trafic AnyAPI, pas sur votre compte.`)
};

const de_app_endpoint_providers_note = /** @type {(inputs: App_Endpoint_Providers_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbarkeit, Latenz und Anteil der Aufrufe, gemessen über den gesamten AnyAPI-Traffic, nicht über dein Konto.`)
};

const ru_app_endpoint_providers_note = /** @type {(inputs: App_Endpoint_Providers_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступность, задержка и доля вызовов измерены по всему трафику AnyAPI, а не по вашему аккаунту.`)
};

const it_app_endpoint_providers_note = /** @type {(inputs: App_Endpoint_Providers_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilità, latenza e quota di chiamate misurate su tutto il traffico AnyAPI, non sul tuo account.`)
};

/**
* | output |
* | --- |
* | "Uptime, latency and share of calls measured across all AnyAPI traffic, not your account." |
*
* @param {App_Endpoint_Providers_NoteInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const app_endpoint_providers_note = /** @type {((inputs?: App_Endpoint_Providers_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Endpoint_Providers_NoteInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_app_endpoint_providers_note(inputs)
	if (locale === "pt-BR") return pt_br2_app_endpoint_providers_note(inputs)
	if (locale === "es") return es_app_endpoint_providers_note(inputs)
	if (locale === "fr") return fr_app_endpoint_providers_note(inputs)
	if (locale === "de") return de_app_endpoint_providers_note(inputs)
	if (locale === "ru") return ru_app_endpoint_providers_note(inputs)
	if (locale === "it") return it_app_endpoint_providers_note(inputs)
	return en_app_endpoint_providers_note(inputs)
});